
define('IMEIManager.IMEI.View'
    , [
        'Backbone'

        , 'imeimanager_imei.tpl'
    ]
    , function
        (
            Backbone

            , imeimanager_imei_tpl
        ) {
        'use strict';

        return Backbone.View.extend({
            template: imeimanager_imei_tpl,

            // events: {
            //     "click [data-action='remove']": "removeIMEI"
            // },

            // removeIMEI: function removeIMEI(e) {
            //     e.preventDefault();

            //     this.model.destory();
            // },

            getContext: function () {
                return {
                    imei: this.model.get('imei')
                }
            }
        })
    });
